// Seller → Carga de envíos. Ver "LYNX — unificación External API/Admin/
// Seller": antes el Seller no tenía ninguna forma de cargar un Delivery
// Current manual (solo existía el visor de Legacy en SellerDeliveries.tsx).
// Reutiliza EXACTAMENTE el mismo formulario que Admin
// (DeliveryIntakeForm) -- la única diferencia es de dónde salen las
// Stores permitidas: acá, de las propias del seller (sellerOwnsStore en
// el backend es quien realmente autoriza, esto solo decide qué mostrar).
import React, { useEffect, useState } from "react";
import Card from "../components/ui/Card";
import { useAuth } from "../context/AuthContext";
import { authFetch } from "../lib/authFetch";
import DeliveryIntakeForm, { DeliveryIntakeStore, DeliveryCreatedResult } from "../components/deliveries/DeliveryIntakeForm";
import DeliveryCreatedModal from "../components/deliveries/DeliveryCreatedModal";

const pageWrapStyle: React.CSSProperties = { display: "flex", flexDirection: "column", gap: "20px" };
const titleStyle: React.CSSProperties = { margin: 0, fontSize: "34px", fontWeight: 800, color: "var(--text-primary)", letterSpacing: "-0.03em" };
const sectionTitleStyle: React.CSSProperties = { margin: 0, fontSize: "18px", fontWeight: 700, color: "var(--text-primary)" };
const sectionTextStyle: React.CSSProperties = { margin: "6px 0 18px 0", color: "var(--text-secondary)", fontSize: "14px" };
const emptyStateStyle: React.CSSProperties = {
  borderRadius: "16px", padding: "16px", fontSize: "14px",
  background: "rgba(185,100,95,0.1)", border: "1px solid rgba(185,100,95,0.24)", color: "var(--danger)",
};

function pickArray<T>(payload: { [key: string]: T[] | undefined }, keys: string[]): T[] {
  for (const key of keys) {
    const value = payload[key];
    if (Array.isArray(value)) return value;
  }
  return [];
}

export default function SellerDeliveryCreate() {
  const { token, userId } = useAuth();

  const [stores, setStores] = useState<DeliveryIntakeStore[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [created, setCreated] = useState<DeliveryCreatedResult | null>(null);

  useEffect(() => {
    const loadStores = async () => {
      if (!token || !userId) return;
      setLoading(true);
      setError("");
      try {
        const roleRes = await authFetch(`/v2/users/${userId}/role`, { token });
        const rolePayload = await roleRes.json().catch(() => ({} as any));
        if (!roleRes.ok || rolePayload?.ok === false) throw new Error(rolePayload?.error || "No se pudo resolver el seller autenticado.");
        const sellerId = rolePayload?.data?.id;
        if (!sellerId) throw new Error("El usuario no tiene seller_data asociado.");

        const storesRes = await authFetch(`/v2/sellers/${sellerId}/store`, { token });
        const storesPayload = await storesRes.json().catch(() => ({} as any));
        if (!storesRes.ok || storesPayload?.ok === false) throw new Error(storesPayload?.error || "No se pudieron cargar las tiendas asociadas.");
        setStores(pickArray<DeliveryIntakeStore>(storesPayload, ["stores", "data", "result"]));
      } catch (err) {
        setError(err instanceof Error ? err.message : "Error cargando datos del seller");
        setStores([]);
      } finally {
        setLoading(false);
      }
    };
    loadStores();
  }, [token, userId]);

  const lockedStoreId = stores.length === 1 ? String(stores[0].id) : undefined;

  return (
    <div style={pageWrapStyle}>
      <h1 style={titleStyle}>Carga de envíos</h1>

      <Card>
        <h2 style={sectionTitleStyle}>Nuevo envío manual</h2>
        <p style={sectionTextStyle}>
          {stores.length === 1
            ? `Tienda: ${stores[0].nombre_fantasia || stores[0].nombreFantasia || `Store ${stores[0].id}`}`
            : "Elegí la Store y la Account del envío -- el precio se calcula automáticamente según el código postal."}
        </p>

        {loading ? (
          <div style={sectionTextStyle}>Cargando tiendas autorizadas...</div>
        ) : error ? (
          <div style={emptyStateStyle}>{error}</div>
        ) : stores.length === 0 ? (
          <div style={emptyStateStyle}>No tenés ninguna tienda asociada todavía. Pedile a un administrador que te vincule una Store para poder cargar envíos.</div>
        ) : (
          <DeliveryIntakeForm token={token} stores={stores} lockedStoreId={lockedStoreId} onCreated={setCreated} />
        )}
      </Card>

      {created ? (
        <DeliveryCreatedModal result={created} token={token} onClose={() => setCreated(null)} />
      ) : null}
    </div>
  );
}
